import { render, staticRenderFns } from "./btnAccess.vue?vue&type=template&id=d8a5a40e"
import script from "./btnAccess.vue?vue&type=script&lang=js"
export * from "./btnAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports